<template lang="pug">
    section
        el-row.root-row.no-padding(:gutter="40")
            el-col(:xl="8" :md="12" :sm="24")
                el-form-item(:label="$t('Status')" prop="status")
                    el-radio-group(v-model="status")
                        el-radio-button(label="enabled") {{ $t('Active') }}
                        el-radio-button(label="disabled") {{ $t('Inactive') }}
                        //- el-radio-button(label="blocked") {{ $t('Blocked') }}
                .flex-row
                    el-form-item(:label="$t('Gender')" prop="gender")
                        el-select.min(placeholder="" v-model="gender")
                            el-option(:label="$t('Mr.')" value="M")
                            el-option(:label="$t('Mrs.')" value="F")
                            el-option(:label="$t('Undefined')" value="X")
                    el-form-item.grow(:label="$t('Salutation')" prop="salutation")
                        el-input(v-model="salutation" maxlength="255" show-word-limit)
                el-row.no-padding(:gutter="20")
                    el-col(:md="12")
                        el-form-item(:label="$t('First name')" prop="first_name")
                            el-input(v-model="firstName" maxlength="255" show-word-limit)
                    el-col(:md="12")
                        el-form-item(:label="$t('Last name')" prop="last_name")
                            el-input(v-model="lastName" maxlength="255" show-word-limit)
                .flex-row
                    el-form-item.grow(:label="$t('Email')" prop="email")
                        el-input(
                            v-model="email"
                            name="member_email"
                            autocomplete="off"
                            maxlength="255"
                            show-word-limit
                        )
                    el-form-item.email-validation-form-item(v-if="enabledExtensions.includes('newsletter')" label=" ")
                        .email-validation-status
                            el-tag.status-tag(
                                v-if="currentEmailValidationStatus === 'valid'"
                                type="success"
                            ) {{ $t('Deliverable') }}
                            el-tag.status-tag(
                                v-else-if="currentEmailValidationStatus === 'invalid'"
                                type="danger"
                            ) {{ $t('Not deliverable') }}
                            el-tag.status-tag(
                                v-else-if="currentEmailValidationStatus === 'unknown'"
                                type="warning"
                            ) {{ $t('Unknown') }}
                            el-tag.status-tag(
                                v-else
                                type="info"
                            ) {{ $t('Not validated') }}
                            el-button.validate-btn(
                                size="medium"
                                type="primary"
                                plain
                                icon="el-icon-fa-paper-plane fas"
                                :loading="validatingEmail"
                                :disabled="!email"
                                @click="validateEmailDeliverability"
                            ) {{ $t('Validate') }}
                el-form-item(:label="$t('Phone')" prop="phone")
                    el-input(v-model="phone" maxlength="255" show-word-limit)
                el-form-item.whatsapp-consent(v-if="whatsappOrderConsentAvailable" size="mini")
                    el-switch(
                        v-model="whatsappOrderUpdatesConsent"
                        :active-text="$t('Order updates via WhatsApp')"
                    )
                    p.help {{ $t('Whether the customer agreed to receive order updates via WhatsApp. Needs a mobile number to send.') }}
                el-form-item(
                    v-if="preferredCorrespondenceEmailFeatureEnabled"
                    :label="$t('Preferred correspondence email')"
                    prop="preferred_correspondence_email"
                )
                    el-input(v-model="preferredCorrespondenceEmail" maxlength="255" show-word-limit)
                el-form-item(:label="$t('Company')" prop="company")
                    el-input(
                        v-model="company"
                        name="member_company"
                        autocomplete="off"
                        maxlength="255"
                        show-word-limit
                    )
                el-form-item.no-margin(
                    v-if="enabledExtensions.includes('newsletter')"
                    :label="$t('Subscription Topics')"
                )
                    //- allow-create
                    el-select.is-full-width(
                        ref="subscriptionTopicSelect"
                        multiple
                        clearable
                        filterable
                        default-first-option
                        value-key="id"
                        v-model="subscriptionTopics"
                        @change="$refs.subscriptionTopicSelect.blur()"
                    )
                        el-option(
                            v-for="subscriptionTopic in [ ...options.subscriptionTopic.items, ...subscriptionTopics.filter(topic => !options.subscriptionTopic.items.some(el => el.id === topic.id)) ]"
                            :key="subscriptionTopic.id"
                            :label="subscriptionTopic.name"
                            :value="subscriptionTopic"
                        ) {{ subscriptionTopic.name }}
                .password-reset-flex-col
                    el-form-item.switch(v-if="isUpdate" size="mini")
                        el-switch(
                            :active-text="$t('Change password')"
                            inactive-color="#ff4949"
                            v-model="changePassword"
                        )
                    el-form-item.input(v-if="! isUpdate || changePassword" :label="$t('Password')" prop="password")
                        el-input(
                            v-model="password"
                            name="member_new_password"
                            autocomplete="new-password"
                            show-password
                            ref="password"
                        )

                el-form-item.mt-2(:label="$t('Avatar')" prop="avatar")
                    el-upload.plus-box(
                        v-if="! avatar"
                        ref="upload"
                        drag :action="uploadEndpoint"
                        accept="image/jpg, image/jpeg, image/png, image/svg+xml"
                        :before-upload="validateUpload"
                        :on-change="updateUploadHeaders"
                        :on-success="uploadSucceed"
                        :on-error="uploadFailed"
                        :headers="uploadHeaders"
                        :data="uploadData"
                    )
                        i.el-icon-plus
                        // i.el-icon-upload.el-icon-fa-cloud-upload-alt.fas
                        .el-upload__text(v-html="$t('upload.drop.plural')")
                        .el-upload__tip(slot="tip") {{ $t('upload.validation', { filetypes: 'jpg/png', size: '3mb' }) }}
                    .avatar-input(v-else :class="{ deleted: avatar.media.deleted }")
                        img(
                            :width="avatar.media.image.width"
                            :height="avatar.media.image.height"
                            :src="avatar.src"
                        )
                        el-button.restore-image(
                            v-if="avatar.media.deleted"
                            circle type="success" size="mini"
                            icon="el-icon-fa-trash-restore fas"
                            @click="restoreAvatar"
                        )
                        el-button.delete-image(
                            v-else
                            circle type="info" size="mini"
                            icon="el-icon-fa-trash-alt far"
                            @click="deleteAvatar"
                        )
                Tags
                ApiTokens(
                    v-if="form.id && !String(form.id).startsWith('new')"
                    :description="$t('API tokens let a server-side integration act as this member and create purchases without a captcha. A token is shown only once when created.')"
                    :fetch="() => memberStore.fetchMemberApiTokens(form.id)"
                    :create="name => memberStore.createMemberApiToken(form.id, name)"
                    :remove="tokenId => memberStore.deleteMemberApiToken(form.id, tokenId)"
                )
            el-col(:xl="16" :md="12" :sm="24")
                Addresses

        .flex-row
            el-form-item.no-margin(size="mini" label=" ")
                el-switch(
                    :active-text="emailVerifiedLabel"
                    v-model="emailVerified"
                )
            el-form-item.no-margin(v-if="!emailVerified && !isUpdate" size="mini" label=" ")
                el-switch(
                    :active-text="$t('Send email verification')"
                    v-model="sendEmailVerification"
                )
</template>

<i18n>
{
    "en": {
        "Email verified at {date}": "Email verified at {date}",
        "Validated via {source} (cached)": "Validated via {source} (cached)",
        "Validated via {source}": "Validated via {source}",
        "{count} member(s) updated": "{count} member(s) updated"
    },
    "de": {
        "API tokens let a server-side integration act as this member and create purchases without a captcha. A token is shown only once when created.": "API-Token erlauben einer serverseitigen Integration, im Namen dieses Mitglieds zu handeln und Käufe ohne Captcha anzulegen. Ein Token wird nur einmalig bei der Erstellung angezeigt.",
        "yyyy-MM-dd": "dd.MM.yyyy",
        "Gender": "Geschlecht",
        "Salutation": "Anrede",
        "First name": "Vorname",
        "Last name": "Nachname",
        "Email": "E-Mail",
        "Phone": "Telefon",
        "Order updates via WhatsApp": "Bestellupdates per WhatsApp",
        "Whether the customer agreed to receive order updates via WhatsApp. Needs a mobile number to send.": "Ob der Kunde eingewilligt hat, Bestellupdates per WhatsApp zu erhalten. Zum Senden ist eine Mobilnummer nötig.",
        "Avatar": "Benutzerbild",
        "Preferred correspondence email": "Bevorzugte Korrespondenz E-Mail",
        "Change password": "Passwort ändern",
        "Password": "Passwort",
        "Company": "Firma",
        "Subscription Topics": "Abonnement-Themen",
        "Mr.": "Herr",
        "Mrs.": "Frau",
        "Undefined": "Unbekannt",
        "Deliverable": "Zustellbar",
        "Not deliverable": "Nicht zustellbar",
        "Unknown": "Unbekannt",
        "Not validated": "Nicht validiert",
        "Validate": "Validieren",
        "Email validation successful!": "E-Mail-Validierung erfolgreich!",
        "Email validation failed!": "E-Mail-Validierung fehlgeschlagen!",
        "Result from cache": "Ergebnis aus Cache",
        "{count} member(s) updated": "{count} Mitglied(er) aktualisiert",
        "Validated via {source}": "Validiert über {source}",
        "Validated via {source} (cached)": "Validiert über {source} (Cache)",
        "Mark email as verified": "E-Mail als verifiziert markieren",
        "Email verified at {date}": "E-Mail verifiziert am {date}",
        "Send email verification": "E-Mail-Verifizierung senden"
    }
}
</i18n>

<script>

import _ from 'lodash'
import uniqid from 'uniqid';

import { useAuthStore, useSetupStore, useRestrictedAreaMemberStore } from '@/stores'
import { ensureFreshToken } from '@/helpers'
import { timestamp2date } from '@/filters'

import store from '@/store'

import Addresses from './Addresses'
import Tags from './Tags'
import ApiTokens from '@/components/ApiTokens'

export default {
    name: 'Main',
    data() {
        return {
            validatingEmail: false,
            lastValidatedEmail: null,
            lastValidationStatus: null,
        }
    },
    components: {
        Addresses,
        Tags,
        ApiTokens
    },
    computed: {
        uploadHeaders() {
            return {
                authorization: `Bearer ${useAuthStore().token}`,
                accept: 'application/json',
            }
        },
        status: {
            get() {
                return _.get(this.form, 'status', 'disabled')
            },
            set(value) {
                this.memberStore.setFormStatus(value)
            }
        },
        gender: {
            get() {
                return _.get(this.form, 'gender', '')
            },
            set(value) {
                this.memberStore.setFormGender(value)
            }
        },
        salutation: {
            get() {
                return _.get(this.form, 'salutation', '')
            },
            set(value) {
                this.memberStore.setFormSalutation(value)
            }
        },
        firstName: {
            get() {
                return _.get(this.form, 'first_name', '')
            },
            set(value) {
                this.memberStore.setFormFirstName(value)
            }
        },
        lastName: {
            get() {
                return _.get(this.form, 'last_name', '')
            },
            set(value) {
                this.memberStore.setFormLastName(value)
            }
        },
        email: {
            get() {
                return _.get(this.form, 'email', '')
            },
            set(value) {
                this.memberStore.setFormEmail(value)
            }
        },
        phone: {
            get() {
                return _.get(this.form, 'phone', '')
            },
            set(value) {
                this.memberStore.setFormPhone(value)
            }
        },
        // The customer's "order updates via WhatsApp" service consent. It only has meaning
        // for the order-notifications addon, which needs both communication AND a shop
        // (there are no order events without a shop) - so gate the toggle on both.
        whatsappOrderConsentAvailable() {
            return this.enabledExtensions.includes('communication')
                && this.enabledExtensions.includes('shop')
        },
        whatsappOrderUpdatesConsent: {
            get() {
                return _.get(this.form, 'whatsapp_order_updates_consent', false)
            },
            set(value) {
                this.memberStore.setFormWhatsappOrderUpdatesConsent(value)
            }
        },

        preferredCorrespondenceEmailFeatureEnabled() {
            let features = _.get(this.activeCms, 'config.template.features') || [];
            return !!features.find(el => el === 'preferred-member-correspondence-email');
        },
        preferredCorrespondenceEmail: {
            get() {
                return _.get(this.form, 'preferred_correspondence_email', '')
            },
            set(value) {
                this.memberStore.setFormPreferredCorrespondenceEmail(value)
            }
        },

        changePassword: {
            get() {
                return _.get(this.form, 'changePassword', false)
            },
            set(value) {
                this.memberStore.setFormChangePassword(value)
                if (value) {
                    this.$nextTick(() => {
                        const el = this.$refs.password.$el
                        const input = el.getElementsByTagName('input');
                        if (input.length) input[0].select();
                    })
                }
            }
        },
        password: {
            get() {
                return _.get(this.form, 'password', '')
            },
            set(value) {
                this.memberStore.setFormPassword(value)
            }
        },
        company: {
            get() {
                return _.get(this.form, 'company', '')
            },
            set(value) {
                this.memberStore.setFormCompany(value)
            }
        },
        emailVerified: {
            get() {
                return _.get(this.form, 'emailVerified', true)
            },
            set(value) {
                this.memberStore.setFormEmailVerified(value)
            }
        },
        emailVerifiedLabel() {
            const verifiedAt = _.get(this.form, 'email_verified_at')
            if (this.isUpdate && verifiedAt) {
                const formatted = timestamp2date(verifiedAt, this.$t('yyyy-MM-dd') + ', HH:mm')
                return this.$t('Email verified at {date}', { date: formatted })
            }
            return this.$t('Mark email as verified')
        },
        sendEmailVerification: {
            get() {
                return _.get(this.form, 'sendEmailVerification', false)
            },
            set(value) {
                this.memberStore.setFormSendEmailVerification(value)
            }
        },
        subscriptionTopics: {
            get() {
                let subscriptionTopics = _.get(this.form, 'subscriptionTopics');
                return subscriptionTopics.map(subscriptionTopic => {
                    if (subscriptionTopic.id.startsWith('new:')) return subscriptionTopic.name
                    else return subscriptionTopic
                })
            },
            set(value) {
                let subscriptionTopics = []
                value.forEach(subscriptionTopic => {
                    if (typeof subscriptionTopic === 'string' || subscriptionTopic instanceof String) {
                        subscriptionTopics.push({
                            id: uniqid('new:'),
                            name: subscriptionTopic,
                        })
                    } else {
                        subscriptionTopics.push(subscriptionTopic)
                    }
                })

                this.memberStore.setFormSubscriptionTopics(subscriptionTopics)
            }
        },
        isUpdate() {
            return !! _.get(this.form, 'id')
        },
        currentEmailValidationStatus() {
            // If we just validated this exact email, show that result
            if (this.lastValidatedEmail && this.lastValidatedEmail === this.email) {
                return this.lastValidationStatus
            }
            // For existing members, show stored status only if email hasn't changed
            const storedEmail = _.get(this.form, 'email', '')
            const storedStatus = _.get(this.form, 'email_validation_status', null)
            if (this.isUpdate && storedEmail === this.email && storedStatus) {
                return storedStatus
            }
            // Email changed or new member - no validation yet
            return null
        },
        avatar() {
            const media = _.find(this.form.media, { scope: 'avatar' })

            if (media) {

                let file
                switch (media.type) {
                    case 'file':
                        file = _.get(media, 'file');
                        break

                    case 'image':
                        file = _.get(media, 'image.source');
                        break

                    case 'video':
                        const isHLS = !! _.get(media, 'video.hls')
                        if (isHLS) {
                            file = _.get(media, 'video.hls');
                        } else {
                            file = _.get(media, 'video.source');
                        }
                        break
                }

                if (file) {
                    const storageRoute = _.trim(
                        `${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
                        '/'
                    );

                    let fit;
                    let table = 'uploads';

                    let id = file.id;
                    const name = file.name;

                    switch (media.type) {
                        case 'file':
                            if (!file.upload) table = 'files';
                            break;

                        case 'image':
                            // const fit = 'fit=fill&w=160&h=160&fill-color=ffffff'
                            // const fit = 'fit&h=160&fill-color=ffffff'

                            fit = 'fit&h=360';

                            if (!file.upload) {
                                table = 'images';
                                id = media.image.id;
                            }
                            break;

                        case 'video':
                            if (!file.upload) {
                                table = 'videos';
                                id = media.video.id;

                                const isHLS = !! _.get(media, 'video.hls')
                                if (isHLS) {
                                    const cdnEndpoint = _.trim(
                                        `${process.env.VUE_APP_CDN_ENDPOINT}${process.env.VUE_APP_CDN_ROOT || ''}`,
                                        '/'
                                    );

                                    return `${cdnEndpoint}/${media.video.hls.path}/${media.video.hls.name}`;
                                }
                            }
                            break;
                    }

                    let src = `${storageRoute}/${table}/${id}/${name}`;
                    if (media.type === 'image' && fit) src += `?${fit}`;

                    return {
                        media,
                        file,
                        src
                    };
                }
            }
        },
        uploadData() {
            let uploadData = {
                'context[type]': 'avatar'
            }
            if (this.form.id) {
                uploadData = {
                    'context[type]': 'avatar',
                    'context[model]': 'Extensions\\RestrictedArea\\Member',
                    'context[id]': this.form.id
                }
            }

            return uploadData
        },
        uploadEndpoint() {
            return `${this.setupStore.uploadEndpoint}/public`
        },
        setupStore() {
            return useSetupStore()
        },
        memberStore() {
            return useRestrictedAreaMemberStore()
        },
        activeCms() {
            return this.setupStore.activeCms
        },
        enabledExtensions() {
            return this.setupStore.enabledExtensions
        },
        form() {
            return this.memberStore.form
        },
        options() {
            return this.memberStore.options
        },
    },
    methods: {
        validateEmailDeliverability() {
            if (!this.email) return

            this.validatingEmail = true
            this.memberStore.validateEmailDeliverability(this.email)
                .then((result) => {
                    // Store the validation result locally
                    this.lastValidatedEmail = result.email
                    this.lastValidationStatus = result.status

                    let message = ''
                    if (result.validation_source) {
                        if (result.cached) {
                            message = this.$t('Validated via {source} (cached)', { source: result.validation_source })
                        } else {
                            message = this.$t('Validated via {source}', { source: result.validation_source })
                        }
                    } else if (result.cached) {
                        message = this.$t('Result from cache')
                    }

                    this.$notify.success({
                        title: this.$t('Email validation successful!'),
                        message,
                        iconClass: 'fas el-icon-fa-check',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 5000,
                    })
                })
                .catch(err => {
                    console.error(err)
                    this.$notify.error({
                        title: this.$t('Email validation failed!'),
                        iconClass: 'fas el-icon-fa-xmark',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                })
                .finally(() => {
                    this.validatingEmail = false
                })
        },
        deleteAvatar() {
            const index = _.findIndex(this.form.media, { scope: 'avatar' })
            if (index >= 0) {
                this.memberStore.markFormMediaAsDeleted(index)
            }
        },
        restoreAvatar() {
            const index = _.findIndex(this.form.media, { scope: 'avatar' })
            if (index >= 0) {
                this.memberStore.unmarkFormMediaAsDeleted(index)
            }
        },
        async updateUploadHeaders() {
            // The computed uploadHeaders reads the store token; make sure it is fresh.
            await ensureFreshToken()
        },
        async validateUpload(file) {
            await this.updateUploadHeaders()
            // if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
            //     this.$notify.error({
            //         title: this.$t('Wrong file type!'),
            //         message: this.$t('Allowed file types are: jpg / png'),
            //         iconClass: 'fas el-icon-fa-xmark',
            //         position: 'bottom-left',
            //         customClass: 'dark',
            //         duration: 8000,
            //     })
            //     return Promise.reject()
            // }
            if (file.size / 1024 / 1024 > 3) {
                // this.$message.error('Avatar picture size can not exceed 2MB!');
                this.$notify.error({
                    title: this.$t('upload.sizeExceeded'),
                    message: this.$t('upload.max', { size: '3mb' }),
                    iconClass: 'fas el-icon-fa-xmark',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000,
                })
                // Reject, never `return false`: an async before-upload always returns a promise,
                // and Element aborts only on rejection - a resolved `false` uploads anyway.
                return Promise.reject()
            }
        },
        async uploadSucceed(response, data) {
            // let image = response
            // image.upload = true

            // if (typeof image.size === 'number') image.size = image.size.toString()
            // delete image.hash
            // delete image.dimensions

            // setTimeout(() => {
            //     if (this.$refs.upload) {
            //         this.$refs.upload.uploadFiles = this.$refs.upload.uploadFiles.filter(el => el.uid !== file.uid)
            //     }
            // }, 1000)

            // // store.commit('ext_restrictedArea_member/form/addImage', { image })
            // this.addImage(image)
            // this.updateUploadHeaders()

            const imageMimeTypes = ['image/jpeg', 'image/gif', 'image/png', 'image/webp'];
            const videoMimeTypes = ['video/mp4', 'video/mpeg', 'video/webm', 'video/quicktime'];

            let type = 'file';
            if (imageMimeTypes.includes(response.mime)) type = 'image';
            else if (videoMimeTypes.includes(response.mime)) type = 'video';

            let image, video, file;
            switch (type) {
                case 'file':
                    file = {
                        id: response.id,
                        name: response.name,
                        preferred_name: response.preferred_name,
                        mime: response.mime,
                        type: 'original',
                        upload: true
                    };
                    break;

                case 'image':
                    image = {
                        id: uniqid('new:'),
                        width: response.dimensions.width,
                        height: response.dimensions.height,
                        source: {
                            id: response.id,
                            name: response.name,
                            preferred_name: response.preferred_name,
                            mime: response.mime,
                            type: 'original',
                            upload: true
                        }
                    };
                    break;

                case 'video':
                    video = {
                        id: uniqid('new:'),
                        width: response.dimensions.width,
                        height: response.dimensions.height,
                        source: {
                            id: response.id,
                            name: response.name,
                            preferred_name: response.preferred_name,
                            mime: response.mime,
                            type: 'original',
                            upload: true
                        }
                    };
                    break;
            }

            const media = {
                id: uniqid('new:'),
                type,
                scope: 'avatar',
                position: this.form.media.length + 1,
                // settings: {
                //     show: {
                //         list: !this.form.media.filter(el => el.type === 'image').length && type === 'image',
                //         detail: true,
                //         highlight: !this.form.media.filter(el => el.type === 'image').length && type === 'image',
                //         disabled: false
                //     }
                // },
                image,
                video,
                file
            };

            setTimeout(() => {
                if (this.$refs.upload) {
                    this.$refs.upload.uploadFiles = this.$refs.upload.uploadFiles.filter(el => el.uid !== file.uid)
                }
            }, 1000)

            // this.form.media.push(media);

            this.memberStore.addFormMedia(media);

            await this.updateUploadHeaders();
        },
        async uploadFailed(err, file) {
            await this.updateUploadHeaders()

            this.$notify.error({
                title: this.$t('upload.notUploaded'),
                message: _.get(file, 'name'),
                iconClass: 'fas el-icon-fa-xmark',
                position: 'bottom-left',
                customClass: 'dark',
                duration: 8000,
            })
        },
    }
}
</script>

<style lang="sass" scoped>
.email-validation-status
    display: flex
    align-items: center
    justify-content: flex-end
    gap: 10px
    .status-tag
        height: 36px
        display: flex
        align-items: center
        font-size: 14px

.password-reset-flex-col
    display: flex
    .el-form-item
        margin: 0
    .switch
        padding-right: 20px
        padding-top: 20px
        // min-height: 63px
        ::v-deep
            .el-form-item__content
                min-height: 44px
                display: flex
                align-items: center
    .input
        flex-grow: 1

// The WhatsApp order-updates consent: switch on its own line, muted hint below.
.whatsapp-consent
    ::v-deep .el-form-item__content
        line-height: 1.4
    .help
        display: block
        margin: 4px 0 0
        font-size: .75rem
        line-height: 1.4
        color: #909399

.el-row.root-row
    & > .el-col + .el-col
        margin-top: 40px
    +res(md)
        display: flex
        & > .el-col + .el-col
            margin-top: 0

.avatar-input
    display: inline-block
    position: relative
    & > img
        max-height: 180px
        max-width: 100%
        width: auto
        border-radius: 3px
        transition: .15s filter ease, .15s opacity ease
        background: $color-skeleton
    .el-button.delete-image,
    .el-button.restore-image
        position: absolute
        top: 5px
        right: 5px
        z-index: 2
        width: 30px
        height: 30px
        opacity: 0
        -webkit-transition: opacity .15s ease
        transition: opacity .15s ease
    &:hover
        .el-button.delete-image,
        .el-button.restore-image
            opacity: 1
    &.deleted
        & > img
            opacity: .6
            filter: grayscale(1) blur(1px)
.el-select.min
    width: 160px
</style>
